export default "__VITE_ASSET__BYzoVM2$__"